import { Box, Card, CardBody, HStack, Skeleton, Text, VStack, } from "@chakra-ui/react";
import { formatPrice, } from "../../../../utils/formatPrice.ts";

export interface ILimitCardProps {
  /**
   * Show skeleton if data is loading
   */
  isLoading?: boolean;

  /**
   * Unique limit identifier
   */
  id?: string;

  /**
   * Limit name
   */
  name?: string;

  /**
   * Total limit amount assigned
   */
  totalAmount?: number;

  /**
   * Remaining amount available
   */
  availableAmount?: number;

  /**
   * Currency code (e.g., USD, EUR)
   */
  currencyCode?: string;

  /**
   * Status of the limit (e.g., active, suspended)
   */
  status?: string;

  /**
   * Optional click handler for opening limit details
   */
  onClick?: () => void;
  cursorType?: "default" | "pointer";
}
export function LimitCard({
  isLoading,
  name,
  availableAmount,
  totalAmount,
  onClick,
  cursorType = "pointer",
}: ILimitCardProps,) {
  return (
    <Skeleton isLoaded={!isLoading}>
      <Card minWidth="215px" variant="filled" borderRadius="lg" cursor={cursorType} onClick={onClick}>
        <CardBody px={5} py={4}>
          <VStack>
            <Box>
              <Text color="black.500" fontWeight="bold" align="left">Доступный лимит</Text>
              <Text color="brand.500" fontWeight="bold" align="left">{name}</Text>
              <HStack alignItems="center" mt={2}>
                <Text color="black.500" fontWeight="bold" align="left">
                  {formatPrice(availableAmount ?? 0, 0,)}
                </Text>
                <Text color="black.500" fontWeight="bold" align="left">из</Text>
                <Text color="black.500" fontWeight="bold" align="left">{formatPrice(totalAmount ?? 0, 0,)}</Text>
              </HStack>
            </Box>
          </VStack>
        </CardBody>
      </Card>
    </Skeleton>
  );
}
